<script setup>
import { useAppStore } from '~/store/main'
const store = useAppStore()

const { setIsLoaderActive } = store
const { t } = useI18n()
const localePath = useLocalePath()

defineProps({
  error: Object,
})

onMounted(() => {
  setTimeout(() => {
    setIsLoaderActive(false)
  }, 500)
})
</script>

<template>
  <NuxtLayout name="default">
    <div class="error">
      <h1 v-if="error.statusCode === 404" class="text_h1 is_c2">
        {{ t('error.404.title') }} - {{ t('error.404.subtitle') }}
      </h1>
      <h1 v-else class="text_h1 is_c2">An error occurred</h1>

      <img class="error__img" src="/images/error.png" alt="error" />

      <div class="error__content">
        <p>{{ t('error.404.text') }}</p>
        <NuxtLink :to="localePath('index')" class="link error__gohome">
          {{ t('error.404.link') }}
        </NuxtLink>
      </div>
    </div>
  </NuxtLayout>
</template>

<style scoped lang="scss">
.error {
  h1 {
    margin: 92px 0 32px 0;
  }

  &__img {
    display: block;
    margin: 0 auto;
  }

  &__content {
    margin: 21px 0 0 0;
  }

  &__gohome {
    display: block;
    margin: 40px 0 0 0;
  }
}
</style>
